export default "__VITE_ASSET__CXPGewZz__"